
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTaxTypeEnum } from '../models/work-tax-type-enum';
import { WorkTaxRateCategoryEnum } from '../models/work-tax-rate-category-enum';

export function getUpdateTaxCodeDtoFormGroup() {
return new FormGroup({
    code: new FormControl<string | undefined>('', [Validators.maxLength(30)]),
    name: new FormControl<string | undefined>('', [Validators.maxLength(255)]),
    taxType: new FormControl<WorkTaxTypeEnum | undefined>(undefined),
    rateCategory: new FormControl<WorkTaxRateCategoryEnum | undefined>(undefined),
    rate: new FormControl<number | undefined>(undefined, [Validators.min(0), Validators.max(100)]),
    validFrom: new FormControl<string | undefined>(undefined),
    validTo: new FormControl<string | undefined>(undefined),
    ledgerAccountId: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(undefined),
    selectable: new FormControl<boolean | undefined>(undefined),
})
;
}
      